/**
 * Design showcase — three inspired directions for Monte Carlo simulator.
 * Pure React/hooks, no external imports, all data hardcoded.
 */
import React, { useState, useEffect, useRef } from 'react';

const ff = "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif";
const ME = { name:'Walshys94', league:'Chicken Loser', playoff:0.44, finals:0.11, champ:0.04, wins:7.0, maxPF:2337 };
const PLAYOFF_SLOTS = 6;
const LEAGUE = [
  {name:'LovingChicken',playoff:0.90,champ:0.18,wins:10.1},
  {name:'jonp24',playoff:0.90,champ:0.17,wins:10.0},
  {name:'preeceman',playoff:0.81,champ:0.12,wins:9.4},
  {name:'ROMANeseCalcio',playoff:0.80,champ:0.11,wins:9.2},
  {name:'Bisto',playoff:0.76,champ:0.09,wins:8.9},
  {name:'Walshys94',playoff:0.44,champ:0.04,wins:7.0,isMe:true},
  {name:'middlein',playoff:0.30,champ:0.03,wins:6.3},
  {name:'BewareTheHare',playoff:0.27,champ:0.02,wins:6.1},
  {name:'gmesa25',playoff:0.27,champ:0.02,wins:6.1},
  {name:'The Biscuits',playoff:0.22,champ:0.01,wins:5.8},
  {name:'Coulda been',playoff:0.21,champ:0.01,wins:5.7},
  {name:'Wangs n Thangs',playoff:0.12,champ:0.00,wins:5.1},
];
const WIN_HIST = [0,0.003,0.01,0.035,0.08,0.13,0.185,0.195,0.165,0.105,0.055,0.025,0.008,0.002,0];
const pct = p => `${Math.round(p*100)}%`;

function Nav({active,onNav}){
  return(
    <div style={{position:'sticky',top:0,zIndex:100,background:'rgba(8,8,8,0.96)',backdropFilter:'blur(12px)',borderBottom:'1px solid rgba(255,255,255,0.06)',padding:'0 32px',display:'flex',alignItems:'center',gap:'32px',height:'52px',fontFamily:ff}}>
      <span style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.2)',textTransform:'uppercase'}}>Concepts</span>
      {['A','B','C'].map(l=>(
        <button key={l} onClick={()=>onNav(l)} style={{background:'none',border:'none',color:active===l?'#FFF':'rgba(255,255,255,0.35)',fontSize:'14px',fontWeight:active===l?700:400,cursor:'pointer',fontFamily:ff,padding:0,transition:'color 0.2s'}}>
          {l}
        </button>
      ))}
    </div>
  );
}

// ══════════════════════════════════════════════
// CONCEPT A  — The Race (playoff bubble map)
// ══════════════════════════════════════════════
function ConceptA(){
  const [on,setOn]=useState(false);
  useEffect(()=>{const t=setTimeout(()=>setOn(true),100);return()=>clearTimeout(t);},[]);
  const myIdx=LEAGUE.findIndex(t=>t.isMe);
  const gap=((LEAGUE[PLAYOFF_SLOTS-1].playoff-ME.playoff)*100).toFixed(0);
  return(
    <div style={{background:'#0C0C0E',borderRadius:'20px',border:'1px solid rgba(255,255,255,0.07)',overflow:'hidden',fontFamily:ff}}>
      {/* header */}
      <div style={{padding:'28px 32px 24px',display:'flex',justifyContent:'space-between',alignItems:'flex-start',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
        <div>
          <div style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase',marginBottom:'4px'}}>{ME.league} · Playoff race</div>
          <div style={{fontSize:'30px',fontWeight:700,color:'#FFF',letterSpacing:'-0.02em'}}>{ME.name}</div>
        </div>
        <div style={{textAlign:'right'}}>
          <div style={{fontSize:'48px',fontWeight:800,color:'#FF9500',letterSpacing:'-0.04em',lineHeight:1}}>{pct(ME.playoff)}</div>
          <div style={{fontSize:'12px',color:'rgba(255,149,0,0.55)',marginTop:'2px'}}>
            {myIdx>=PLAYOFF_SLOTS ? `~${gap}pts behind cutoff` : 'Above the playoff line'}
          </div>
        </div>
      </div>
      {/* race */}
      <div style={{padding:'24px 32px'}}>
        {LEAGUE.map((t,i)=>{
          const above=i<PLAYOFF_SLOTS;
          return(
            <React.Fragment key={t.name}>
              {i===PLAYOFF_SLOTS&&(
                <div style={{display:'flex',alignItems:'center',gap:'10px',margin:'8px 0',opacity:0.6}}>
                  <div style={{flex:1,height:'1px',borderTop:'1px dashed rgba(255,255,255,0.2)'}}/>
                  <span style={{fontSize:'10px',fontWeight:600,letterSpacing:'1.5px',color:'rgba(255,255,255,0.35)',textTransform:'uppercase',whiteSpace:'nowrap'}}>Playoff line — Top {PLAYOFF_SLOTS}</span>
                  <div style={{flex:1,height:'1px',borderTop:'1px dashed rgba(255,255,255,0.2)'}}/>
                </div>
              )}
              <div style={{display:'grid',gridTemplateColumns:'24px 140px 1fr 46px',alignItems:'center',gap:'10px',padding:'5px 0'}}>
                <div style={{fontSize:'12px',color:'rgba(255,255,255,0.18)',textAlign:'right'}}>{i+1}</div>
                <div style={{fontSize:t.isMe?'15px':'13px',fontWeight:t.isMe?700:400,color:t.isMe?'#FFF':above?'rgba(255,255,255,0.55)':'rgba(255,255,255,0.25)',display:'flex',alignItems:'center',gap:'7px'}}>
                  {t.name}
                  {t.isMe&&<span style={{fontSize:'9px',fontWeight:700,letterSpacing:'1px',background:'#FF9500',color:'#000',borderRadius:'3px',padding:'1px 5px'}}>YOU</span>}
                </div>
                <div style={{height:'5px',borderRadius:'3px',background:'rgba(255,255,255,0.05)',overflow:'hidden'}}>
                  <div style={{height:'100%',width:on?`${t.playoff*100}%`:'0%',background:t.isMe?'linear-gradient(90deg,#FF9500,#FFB800)':above?'rgba(255,255,255,0.42)':'rgba(255,255,255,0.14)',borderRadius:'3px',transition:`width 0.8s cubic-bezier(0.16,1,0.3,1) ${i*35}ms`,boxShadow:t.isMe?'0 0 10px rgba(255,149,0,0.5)':'none'}}/>
                </div>
                <div style={{fontSize:'12px',fontWeight:t.isMe?700:400,color:t.isMe?'#FF9500':above?'rgba(255,255,255,0.5)':'rgba(255,255,255,0.22)',textAlign:'right'}}>{pct(t.playoff)}</div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      {/* secondary stats */}
      <div style={{borderTop:'1px solid rgba(255,255,255,0.05)',padding:'18px 32px',display:'flex',gap:'28px'}}>
        {[{l:'Reach finals',v:pct(ME.finals),c:'#5AC8FA'},{l:'Win title',v:pct(ME.champ),c:'#34C759'},{l:'Expected wins',v:'7.0',c:'rgba(255,255,255,0.55)'},{l:'Median max PF',v:'2,337',c:'rgba(255,255,255,0.55)'}].map(({l,v,c})=>(
          <div key={l}>
            <div style={{fontSize:'10px',fontWeight:600,letterSpacing:'1.5px',color:'rgba(255,255,255,0.2)',textTransform:'uppercase',marginBottom:'3px'}}>{l}</div>
            <div style={{fontSize:'18px',fontWeight:700,color:c,letterSpacing:'-0.02em'}}>{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════
// CONCEPT B  — The Story (narrative + dot track)
// ══════════════════════════════════════════════
function ConceptB(){
  const [on,setOn]=useState(false);
  useEffect(()=>{const t=setTimeout(()=>setOn(true),100);return()=>clearTimeout(t);},[]);
  const outcomes=[
    {label:'Miss playoffs',prob:1-ME.playoff,color:'#FF3B30'},
    {label:'Playoffs, early exit',prob:ME.playoff-ME.finals,color:'#FF9500'},
    {label:'Reach finals',prob:ME.finals-ME.champ,color:'#5AC8FA'},
    {label:'Win championship 🏆',prob:ME.champ,color:'#34C759'},
  ];
  return(
    <div style={{background:'#0C0C0E',borderRadius:'20px',border:'1px solid rgba(255,255,255,0.07)',overflow:'hidden',fontFamily:ff}}>
      {/* narrative hero */}
      <div style={{padding:'36px 40px',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
        <div style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase',marginBottom:'10px'}}>{ME.name} · {ME.league}</div>
        <div style={{fontSize:'22px',fontWeight:400,color:'rgba(255,255,255,0.5)',lineHeight:1.45,marginBottom:'24px',maxWidth:'520px'}}>
          Across 10,000 simulated seasons,{' '}
          <span style={{color:'#FFF',fontWeight:700}}>{ME.name} makes the playoffs in {pct(ME.playoff)} of them.</span>{' '}
          A title happens only {pct(ME.champ)} of the time.
        </div>
        {/* stacked outcome bar */}
        <div style={{height:'22px',borderRadius:'5px',overflow:'hidden',display:'flex',marginBottom:'12px'}}>
          {outcomes.map((o,i)=>{
            let cum=outcomes.slice(0,i).reduce((a,b)=>a+b.prob,0);
            return(
              <div key={o.label} style={{width:on?`${o.prob*100}%`:'0%',background:o.color,opacity:0.72,transition:`width 1s cubic-bezier(0.16,1,0.3,1) ${i*100}ms`,flexShrink:0}} title={`${o.label}: ${pct(o.prob)}`}/>
            );
          })}
        </div>
        <div style={{display:'flex',gap:'16px',flexWrap:'wrap'}}>
          {outcomes.map(o=>(
            <div key={o.label} style={{display:'flex',alignItems:'center',gap:'5px'}}>
              <div style={{width:'8px',height:'8px',borderRadius:'2px',background:o.color,opacity:0.72,flexShrink:0}}/>
              <span style={{fontSize:'11px',color:'rgba(255,255,255,0.35)'}}>{o.label}</span>
              <span style={{fontSize:'11px',fontWeight:700,color:o.color}}>{pct(o.prob)}</span>
            </div>
          ))}
        </div>
      </div>
      {/* win distribution */}
      <div style={{padding:'28px 40px',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
        <div style={{fontSize:'11px',fontWeight:600,letterSpacing:'1.5px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase',marginBottom:'16px'}}>Win distribution</div>
        <div style={{display:'flex',alignItems:'flex-end',gap:'4px',height:'80px',position:'relative'}}>
          {WIN_HIST.map((p,w)=>{
            const h=p/0.2*100;
            const inP=w>=7;
            return(
              <div key={w} style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-end',height:'100%'}}>
                {w===7&&<div style={{position:'absolute',left:`${(7/14)*100}%`,top:0,bottom:0,borderLeft:'1px dashed rgba(52,199,89,0.3)',pointerEvents:'none'}}/>}
                <div style={{width:'100%',height:on?`${h}%`:'0%',background:inP?`rgba(52,199,89,${0.35+p*3})`:`rgba(255,255,255,${0.1+p*2})`,borderRadius:'2px 2px 0 0',transition:`height 0.55s cubic-bezier(0.16,1,0.3,1) ${w*25}ms`}}/>
              </div>
            );
          })}
        </div>
        <div style={{display:'flex',justifyContent:'space-between',marginTop:'5px'}}>
          <span style={{fontSize:'10px',color:'rgba(255,255,255,0.18)'}}>0 wins</span>
          <span style={{fontSize:'10px',color:'rgba(52,199,89,0.5)'}}>← playoff zone →</span>
          <span style={{fontSize:'10px',color:'rgba(255,255,255,0.18)'}}>14 wins</span>
        </div>
      </div>
      {/* dot plot — all teams */}
      <div style={{padding:'24px 40px'}}>
        <div style={{fontSize:'11px',fontWeight:600,letterSpacing:'1.5px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase',marginBottom:'16px'}}>Where you stand</div>
        <div style={{position:'relative',height:'44px'}}>
          <div style={{position:'absolute',left:0,right:0,top:'17px',height:'1px',background:'rgba(255,255,255,0.06)'}}/>
          <div style={{position:'absolute',left:`${LEAGUE[PLAYOFF_SLOTS-1].playoff*100}%`,top:'6px',transform:'translateX(-50%)',display:'flex',flexDirection:'column',alignItems:'center',gap:'1px'}}>
            <div style={{fontSize:'8px',color:'rgba(255,255,255,0.28)',fontWeight:600,letterSpacing:'0.5px',whiteSpace:'nowrap'}}>CUTOFF</div>
            <div style={{width:'1px',height:'20px',background:'rgba(255,255,255,0.2)'}}/>
          </div>
          {LEAGUE.map((t,i)=>(
            <div key={t.name} title={`${t.name}: ${pct(t.playoff)}`} style={{position:'absolute',left:on?`${t.playoff*100}%`:'0%',top:t.isMe?'8px':'12px',transform:'translateX(-50%)',width:t.isMe?'18px':'10px',height:t.isMe?'18px':'10px',borderRadius:'50%',background:t.isMe?'#FF9500':i<PLAYOFF_SLOTS?'rgba(255,255,255,0.48)':'rgba(255,255,255,0.18)',boxShadow:t.isMe?'0 0 12px rgba(255,149,0,0.7)':'none',transition:`left 0.8s cubic-bezier(0.16,1,0.3,1) ${i*35}ms`,zIndex:t.isMe?10:1}}/>
          ))}
        </div>
        <div style={{marginTop:'10px',display:'flex',alignItems:'center',gap:'8px'}}>
          <div style={{width:'11px',height:'11px',borderRadius:'50%',background:'#FF9500',boxShadow:'0 0 8px rgba(255,149,0,0.6)',flexShrink:0}}/>
          <span style={{fontSize:'13px',color:'rgba(255,255,255,0.45)'}}>
            {ME.name} — {pct(ME.playoff)} playoff odds · {LEAGUE.findIndex(t=>t.isMe)+1}th in league · {LEAGUE.findIndex(t=>t.isMe)>=PLAYOFF_SLOTS?`${LEAGUE.findIndex(t=>t.isMe)-PLAYOFF_SLOTS+1} spots out`:'In the playoffs'}
          </span>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════
// CONCEPT C  — The Sim (watch dots land, canvas)
// ══════════════════════════════════════════════
function ConceptC(){
  const ref=useRef(null);
  const [count,setCount]=useState(0);
  const [running,setRunning]=useState(false);
  const [done,setDone]=useState(false);
  const frame=useRef(null);
  const dots=useRef([]);
  const cnt=useRef(0);
  const TOTAL=2000,W=600,H=200;
  const wx=w=>22+(w/14)*(W-44);
  const oy=o=>H-22-o*50;

  const run=()=>{
    setRunning(true);setDone(false);setCount(0);
    dots.current=[];cnt.current=0;
    const cv=ref.current;if(!cv)return;
    const ctx=cv.getContext('2d');
    const step=()=>{
      const batch=15;
      for(let i=0;i<batch;i++){
        if(cnt.current>=TOTAL)break;
        const wins=Math.round(Math.max(0,Math.min(14,7+(Math.random()-0.5)*5+(Math.random()-0.5)*3)));
        const r=Math.random();
        const o=r<(1-ME.playoff)?0:r<(ME.playoff-ME.finals+ME.playoff)?1:r<(ME.playoff-ME.champ)?2:3;
        // Simpler: use prob directly
        const or=Math.random();
        const outcome=or<ME.champ?3:or<ME.finals?2:or<ME.playoff?1:0;
        dots.current.push({x:wx(wins)+(Math.random()-0.5)*14,y:oy(outcome)+(Math.random()-0.5)*20,outcome,op:0});
        cnt.current++;
      }
      setCount(cnt.current);
      ctx.clearRect(0,0,W,H);
      // Grid
      ctx.strokeStyle='rgba(255,255,255,0.03)';ctx.lineWidth=1;
      for(let w=0;w<=14;w+=2){ctx.beginPath();ctx.moveTo(wx(w),0);ctx.lineTo(wx(w),H);ctx.stroke();}
      // Cutline
      ctx.strokeStyle='rgba(52,199,89,0.2)';ctx.setLineDash([3,4]);
      ctx.beginPath();ctx.moveTo(wx(7),0);ctx.lineTo(wx(7),H);ctx.stroke();
      ctx.setLineDash([]);
      // Y labels
      ctx.fillStyle='rgba(255,255,255,0.18)';ctx.font=`10px ${ff}`;ctx.textAlign='left';
      ['Miss','Playoffs','Finals','🏆'].forEach((l,i)=>{ctx.fillText(l,2,H-10-i*50);});
      // Dots
      const COLS=['rgba(255,59,48,','rgba(255,149,0,','rgba(90,200,250,','rgba(52,199,89,'];
      for(const d of dots.current){
        d.op=Math.min(0.65,d.op+0.12);
        ctx.beginPath();ctx.arc(d.x,d.y,2.2,0,Math.PI*2);
        ctx.fillStyle=COLS[d.outcome]+d.op+')';ctx.fill();
      }
      if(cnt.current<TOTAL){frame.current=requestAnimationFrame(step);}
      else{setRunning(false);setDone(true);}
    };
    frame.current=requestAnimationFrame(step);
  };
  useEffect(()=>()=>{if(frame.current)cancelAnimationFrame(frame.current);},[]);

  return(
    <div style={{background:'#0C0C0E',borderRadius:'20px',border:'1px solid rgba(255,255,255,0.07)',overflow:'hidden',fontFamily:ff}}>
      <div style={{padding:'28px 32px 24px'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'20px'}}>
          <div>
            <div style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase',marginBottom:'4px'}}>{ME.name} · {ME.league}</div>
            <div style={{fontSize:'24px',fontWeight:700,color:'#FFF',letterSpacing:'-0.02em'}}>
              {done?`${TOTAL.toLocaleString()} seasons, simulated.`:running?`Season ${count.toLocaleString()} of ${TOTAL.toLocaleString()}…`:'Watch 2,000 seasons run.'}
            </div>
            {done&&<div style={{fontSize:'13px',color:'rgba(255,255,255,0.35)',marginTop:'4px'}}>Each dot = one possible season. Color = how far you went.</div>}
          </div>
          <button onClick={run} disabled={running} style={{background:running?'rgba(255,255,255,0.04)':'#FFF',color:running?'rgba(255,255,255,0.3)':'#000',border:'none',borderRadius:'10px',padding:'11px 22px',fontSize:'14px',fontWeight:600,cursor:running?'default':'pointer',transition:'all 0.2s',fontFamily:ff,display:'flex',alignItems:'center',gap:'7px',flexShrink:0}}>
            {running?<><span style={{animation:'spn 0.6s linear infinite',display:'inline-block'}}>🏈</span>Running</>:done?'↺ Re-run':'▶ Run'}
          </button>
        </div>
        <canvas ref={ref} width={W} height={H} style={{width:'100%',height:'auto',borderRadius:'8px',background:'rgba(255,255,255,0.015)',display:'block'}}/>
        <div style={{display:'flex',justifyContent:'space-between',padding:'4px 22px 0',marginBottom:'14px'}}>
          {[0,2,4,6,8,10,12,14].map(w=><span key={w} style={{fontSize:'10px',color:'rgba(255,255,255,0.18)'}}>{w}W</span>)}
        </div>
        <div style={{display:'flex',gap:'18px',flexWrap:'wrap'}}>
          {[{l:'Miss playoffs',c:'rgba(255,59,48,0.8)',v:pct(1-ME.playoff)},{l:'Make playoffs',c:'rgba(255,149,0,0.8)',v:pct(ME.playoff-ME.finals)},{l:'Reach finals',c:'rgba(90,200,250,0.8)',v:pct(ME.finals-ME.champ)},{l:'Win title 🏆',c:'rgba(52,199,89,0.8)',v:pct(ME.champ)}].map(({l,c,v})=>(
            <div key={l} style={{display:'flex',alignItems:'center',gap:'5px'}}>
              <div style={{width:'8px',height:'8px',borderRadius:'50%',background:c,flexShrink:0}}/>
              <span style={{fontSize:'11px',color:'rgba(255,255,255,0.35)'}}>{l}</span>
              <span style={{fontSize:'11px',fontWeight:700,color:c}}>{v}</span>
            </div>
          ))}
        </div>
      </div>
      {done&&(
        <div style={{borderTop:'1px solid rgba(255,255,255,0.05)',padding:'18px 32px',display:'flex',gap:'24px',flexWrap:'wrap',animation:'fdin 0.5s ease'}}>
          {[{l:'Playoffs',v:pct(ME.playoff),c:'#FF9500'},{l:'Finals',v:pct(ME.finals),c:'#5AC8FA'},{l:'Title',v:pct(ME.champ),c:'#34C759'},{l:'Exp. wins',v:'7.0',c:'rgba(255,255,255,0.55)'}].map(({l,v,c})=>(
            <div key={l}><div style={{fontSize:'10px',fontWeight:600,letterSpacing:'1.5px',color:'rgba(255,255,255,0.2)',textTransform:'uppercase',marginBottom:'3px'}}>{l}</div><div style={{fontSize:'20px',fontWeight:700,color:c,letterSpacing:'-0.02em'}}>{v}</div></div>
          ))}
        </div>
      )}
      <style>{`@keyframes spn{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes fdin{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
}

export default function DesignShowcase(){
  const [active,setActive]=useState('A');
  const scroll=l=>{
    document.getElementById('concept-'+l)?.scrollIntoView({behavior:'smooth',block:'start'});
    setActive(l);
  };
  return(
    <div style={{minHeight:'100vh',background:'#080808',fontFamily:ff}}>
      <Nav active={active} onNav={scroll}/>
      <div style={{maxWidth:'700px',margin:'0 auto',padding:'0 24px 120px'}}>
        {/* Hero */}
        <div style={{textAlign:'center',padding:'64px 0 48px'}}>
          <div style={{fontSize:'11px',fontWeight:600,letterSpacing:'3px',color:'rgba(255,255,255,0.2)',textTransform:'uppercase',marginBottom:'14px'}}>Monte Carlo · Design Review</div>
          <div style={{fontSize:'48px',fontWeight:700,color:'#FFF',letterSpacing:'-0.03em',lineHeight:1.05,marginBottom:'14px'}}>Three directions.</div>
          <div style={{fontSize:'17px',color:'rgba(255,255,255,0.38)',maxWidth:'420px',margin:'0 auto',lineHeight:1.55}}>Same data. Same league. Pick what feels right and we build from there.</div>
        </div>

        {/* A */}
        <div id="concept-A" style={{paddingTop:'56px',paddingBottom:'20px'}}>
          <div style={{display:'flex',alignItems:'baseline',gap:'14px',marginBottom:'6px'}}>
            <span style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase'}}>A</span>
            <span style={{fontSize:'26px',fontWeight:700,color:'#FFF',letterSpacing:'-0.02em'}}>The Race</span>
          </div>
          <div style={{fontSize:'14px',color:'rgba(255,255,255,0.38)',marginBottom:'20px',lineHeight:1.5}}>All 12 teams ranked by playoff odds. Playoff cutline visible. You see immediately where you stand and how far the gap is. Every number has context because you see the whole field.</div>
        </div>
        <ConceptA/>

        {/* B */}
        <div id="concept-B" style={{paddingTop:'72px',paddingBottom:'20px'}}>
          <div style={{display:'flex',alignItems:'baseline',gap:'14px',marginBottom:'6px'}}>
            <span style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase'}}>B</span>
            <span style={{fontSize:'26px',fontWeight:700,color:'#FFF',letterSpacing:'-0.02em'}}>The Story</span>
          </div>
          <div style={{fontSize:'14px',color:'rgba(255,255,255,0.38)',marginBottom:'20px',lineHeight:1.5}}>Narrative-first. Reads like a sentence. A stacked bar shows how each simulated season ends. A dot track shows your position vs. the whole league on a single axis.</div>
        </div>
        <ConceptB/>

        {/* C */}
        <div id="concept-C" style={{paddingTop:'72px',paddingBottom:'20px'}}>
          <div style={{display:'flex',alignItems:'baseline',gap:'14px',marginBottom:'6px'}}>
            <span style={{fontSize:'11px',fontWeight:600,letterSpacing:'2px',color:'rgba(255,255,255,0.22)',textTransform:'uppercase'}}>C</span>
            <span style={{fontSize:'26px',fontWeight:700,color:'#FFF',letterSpacing:'-0.02em'}}>The Sim</span>
          </div>
          <div style={{fontSize:'14px',color:'rgba(255,255,255,0.38)',marginBottom:'20px',lineHeight:1.5}}>Hit Run and watch 2,000 seasons land on a canvas — each dot a full simulated season. Red = miss. Orange = playoffs. Blue = finals. Green = champion. The Monte Carlo becomes visual and visceral.</div>
        </div>
        <ConceptC/>
      </div>
    </div>
  );
}
